import { render, staticRenderFns } from "./kuesioner.vue?vue&type=template&id=675a1d9c&"
import script from "./kuesioner.vue?vue&type=script&lang=js&"
export * from "./kuesioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QRadio} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QRadio}, component.options.components || {})
